module.exports = __webpack_public_path__ + "img/sponsors@2x.440eef06.png";